const parseIfString = (amount: string | number) => {
  if (typeof amount === 'string') {
    return parseInt(amount, 10) || 0;
  }

  return amount;
};

const centsFromDollars = (amount: string | number) => {
  const amountDollars = parseFloat(`${amount}`) || 0;
  return Math.round(amountDollars * 100);
};

const isValid = (token: string) => {
  return /^[-\$]?[\d\,]*\.?\d*$/.test(token);
};

const dollarsFromCents = (amount: string | number, format = false) => {
  const amountCents = parseIfString(amount) / 100;
  return format ? amountCents.toFixed(2) : amountCents;
};

export const formatCents = (
  amount: string | number,
  { currency = '', showCents = true, showPositiveSign = false } = {}
) => {
  const amountDollars = dollarsFromCents(amount) as number;
  const chars = Math.round(amountDollars * 100)
    .toString()
    .replace('-', '')
    .split('');
  const cents = chars.splice(-2, 2);
  const length = chars.length;
  const dollars = chars.map((t, i) =>
    (length - i) % 3 === 0 && i !== 0 ? `,${t}` : t
  );
  const positiveSign = showPositiveSign && amountDollars > 0 ? '+' : '';
  const sign = amountDollars < 0 ? '-' : positiveSign;

  const dollarsString = dollars.length ? dollars.join('') : '0';
  const centsString =
    cents.length === 2 ? cents.join('') : `0${cents.join('')}`;

  return `${sign}${currency}${dollarsString}${
    showCents ? `.${centsString}` : ''
  }`;
};

export const parseCents = (rawValue: string, fallback = NaN) => {
  const tokenString = rawValue || '';
  let dollars = parseFloat(tokenString.replace(/[^\d.]/g, ''));
  return isValid(tokenString) ? centsFromDollars(dollars) : fallback;
};

// Constrain a value between a minimum and a maximum
export const clamp = (value: number, min = 0, max = 100) => {
  return Math.max(min, Math.min(max, value));
};
